import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("获取表信息")

import {
  NForm,
  NFormItem,
  NInput,
  NSelect,
  NTransfer,
  NInputGroup,
  NButton,
} from "naive-ui";
import { useMainStore } from "@/store/main";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useMainStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(NForm), null, {
      default: _withCtx(() => [
        _createVNode(_unref(NFormItem), { label: "数据库类型" }, {
          default: _withCtx(() => [
            _createVNode(_unref(NSelect), {
              value: _unref(store).dbType,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(store).dbType) = $event)),
              options: [{ value: 'MySql', label: 'MySql' }]
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_unref(NFormItem), { label: "数据库URL" }, {
          default: _withCtx(() => [
            _createVNode(_unref(NInput), {
              value: _unref(store).dbUrl,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(store).dbUrl) = $event)),
              placeholder: "必填,示例:jdbc:mysql://ip:port/dbName"
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_unref(NFormItem), { label: "用户名" }, {
          default: _withCtx(() => [
            _createVNode(_unref(NInput), {
              value: _unref(store).dbUserName,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(store).dbUserName) = $event))
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_unref(NFormItem), { label: "密码" }, {
          default: _withCtx(() => [
            _createVNode(_unref(NInputGroup), null, {
              default: _withCtx(() => [
                _createVNode(_unref(NInput), {
                  type: "password",
                  "show-password-on": "mousedown",
                  value: _unref(store).dbPassword,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(store).dbPassword) = $event))
                }, null, 8, ["value"]),
                _createVNode(_unref(NButton), {
                  onClick: _unref(store).getTables
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(NTransfer), {
      value: _unref(store).tables,
      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(store).tables) = $event)),
      options: _unref(store).allTables,
      size: "large",
      style: {"width":"100%","height":"455px"},
      "target-title": "已选择数据表",
      "source-title": "全部数据表"
    }, null, 8, ["value", "options"])
  ], 64))
}
}

})